import React from 'react';

const Violet = () => {
  return <div>Violet</div>;
};

export default Violet;
